var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.getComponent.component,
    _vm._b(
      {
        tag: "component",
        class: {
          "soli-round": _setup.breakpoint.smAndUp || !_vm.fullscreen,
          "sub-menu-modal": _vm.subMenuModal,
        },
        attrs: {
          fullscreen: _vm.fullscreen ? _setup.breakpoint.xs : false,
          "content-class": [
            "responsive-modal soli-round",
            _vm.subMenuModal ? "sub-menu-modal" : "",
          ].join(" "),
        },
        on: {
          keydown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
            )
              return null
            return _setup.reset()
          },
          "click:outside": function ($event) {
            return _setup.reset()
          },
        },
        model: {
          value: _setup.show,
          callback: function ($$v) {
            _setup.show = $$v
          },
          expression: "show",
        },
      },
      "component",
      { ..._setup.getComponent.props },
      false
    ),
    [
      _c(
        "v-card",
        {
          staticClass: "responsive-modal-card safe-bottom",
          class: {
            "half-round": _setup.breakpoint.smAndUp || !_vm.fullscreen,
            "soli-grey": !_vm.color,
          },
          attrs: {
            flat: "",
            color: _vm.color,
            dark: !!_vm.color,
            light: !_vm.color,
          },
        },
        [
          _c(
            "v-btn",
            {
              staticClass: "modal-close-btn",
              attrs: { icon: "", color: _vm.color ? "white" : "dark" },
              on: {
                click: function ($event) {
                  return _setup.reset()
                },
              },
            },
            [_c("v-icon", [_vm._v("clear")])],
            1
          ),
          _vm._v(" "),
          _c(
            "v-container",
            { staticClass: "modal-header py-0" },
            [
              _c(
                "v-card-title",
                { staticClass: "soli-text-shadow" },
                [_vm._v(_vm._s(_vm.title) + " "), _vm._t("title")],
                2
              ),
              _vm._v(" "),
              _vm.subtitle || _vm.$slots.subtitle
                ? _c(
                    "v-card-subtitle",
                    [_vm._v(_vm._s(_vm.subtitle) + " "), _vm._t("subtitle")],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$slots.body
                ? _c(
                    "v-card-text",
                    { staticClass: "modal-body" },
                    [_vm._t("body")],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.$slots.cover
            ? _c(
                "div",
                {
                  staticClass: "modal-cover half-round",
                  class: { "expanded-cover": _vm.expandCover },
                  on: {
                    overflow: function ($event) {
                      return _setup.overflow()
                    },
                  },
                },
                [_vm._t("cover")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$slots.footer
            ? _c("div", { staticClass: "modal-footer" }, [_vm._t("footer")], 2)
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }